import React, { useState } from 'react';
import { FormControlLabel, Checkbox, Typography, Card, Tabs, Tab, Box } from '@mui/material';

function AgreementLab(props) {
    const [agreementChecked, setAgreementChecked] = useState(false);
    const [languageTab, setLanguageTab] = useState(0);

    const agreementTextIT = `
Le macchine virtuali messe a disposizione all'interno del presente laboratorio sono di natura non persistente e non sono soggette ad alcuna procedura di backup o conservazione dei dati.
Pertanto, tutti i dati, i file, le configurazioni e i documenti memorizzati sulle macchine virtuali saranno eliminati in modo definitivo e irreversibile in caso di spegnimento, riavvio o disallocazione della macchina virtuale.
Gli utenti sono esclusivamente responsabili del salvataggio dei propri lavori e sono tenuti ad avvalersi unicamente di servizi di archiviazione esterni, quali i servizi Google Workspace (ad es. Google Drive), per la conservazione e il ripristino dei propri elaborati tra una sessione e l'altra.
Le macchine virtuali possono essere soggette ad attività di manutenzione, sia pianificate sia non pianificate. Durante tali attività potranno verificarsi rallentamenti del servizio, indisponibilità temporanee e/o riavvii automatici, anche in assenza di preavviso.
`;


    const agreementTextEN = `
The virtual machines provided as part of this laboratory are non-persistent and are not subject to any backup or data retention procedures.
Accordingly, all data, files, configurations, and documents stored on the virtual machines shall be permanently and irreversibly deleted in the event of shutdown, restart, or deallocation.
Users are solely responsible for saving their work and must rely exclusively on external storage services, such as Google Workspace services (e.g., Google Drive), for the preservation and restoration of their assignments between sessions.
The virtual machines may be subject to planned or unplanned maintenance activities. During such activities, service slowdowns, temporary unavailability, and/or automatic system restarts may occur without prior notice.
`;

    const { onCompletion } = props;

    const toggleAgreement = () => {
        if (agreementChecked) {
            setAgreementChecked(false);
            onCompletion(false);
        } else {
            setAgreementChecked(true);
            onCompletion(true);
        }
    };

    const handleTabChange = (event, newValue) => {
        setLanguageTab(newValue);
    };


    return (
        <Card sx={{ padding: 3 }}>
            <Typography variant="h6" align="center" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
                Nota sulla mancata persistenza delle macchine virtuali / Notice Regarding the Non-Persistence of Virtual Machines
            </Typography>

            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                <Tabs
                    value={languageTab}
                    onChange={handleTabChange}
                    centered
                    sx={{
                        '& .MuiTab-root': {
                            fontWeight: 500,
                            fontSize: '0.95rem',
                            textTransform: 'none'
                        },
                        '& .MuiTab-root.Mui-selected': {
                            color: '#a71e3b'
                        },
                        '& .MuiTabs-indicator': {
                            backgroundColor: '#a71e3b'
                        }
                    }}
                >
                    <Tab label="Italiano" />
                    <Tab label="English" />
                </Tabs>
            </Box>

            <Box sx={{ mt: 2 }}>
                {languageTab === 0 && (
                    <Typography variant="body2" align="justify" sx={{ mb: 3, lineHeight: 1.8, color: '#555' }}>
                        {agreementTextIT}
                    </Typography>
                )}
                {languageTab === 1 && (
                    <Typography variant="body2" align="justify" sx={{ mb: 3, lineHeight: 1.8, color: '#555' }}>
                        {agreementTextEN}
                    </Typography>
                )}
            </Box>

            <FormControlLabel
                control={
                    <Checkbox
                        checked={agreementChecked}
                        onChange={toggleAgreement}
                        name="agreementCheckbox"
                        sx={{
                            color: '#a71e3b',
                            '&.Mui-checked': {
                                color: '#a71e3b'
                            }
                        }}
                    />
                }
                label="Accetto / I accept"
                sx={{ mt: 2, fontWeight: 500 }}
            />
        </Card>
    );

}


export default AgreementLab;
